module.exports = __webpack_public_path__ + "static/media/34.e864c2b0.jpg";